import { __rest, __awaiter, __generator, __assign } from '../../node_modules/tslib/tslib.es6.js';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import _toNumber from 'lodash/toNumber';
import React, { useState, useCallback, useEffect } from 'react';
import { searchBrandClubsForUserV2, getUnauthedSearchBrandClubs } from '../../api/graphQl/brand.js';
import { ProductOperation, UNAUTHENTICATED_SEARCH_PRODUCTS } from '../../api/graphQl/product.js';
import '../../Components/Animation/AnimationDot.js';
import '../../Components/Button/BackButton.js';
import { Button } from '../../Components/Button/Button.js';
import '../../Components/Button/CloseButton.js';
import '../../Components/Button/CustomDtcBagButton.js';
import '../../Components/BuyBoxDialog/BuyBoxType.js';
import '../../Components/BuyBoxDialog/PriceDialogContent.js';
import '../../Components/BuyBoxDialog/ProductPrice.js';
import '../../Components/ImageCropper/ImageCropper.js';
import { useJoinBrandClubWithRedirect } from '../../utils/hooks/useJoinBrandClub.js';
import { FilterDialog } from '../BrandclubNavigation/FilterDialog.js';
import ProductBrandCard from '../components/BrandclubProductCard/ProductBrandCard.js';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';
import { StoreBrandingType } from '../type.js';
import SearchProductGrid from './SearchProductGrid.js';
import { searchParamsToSearchFilters } from './searchResultsUtils.js';

var _a, _b;
var PAGE_SIZE = 60;
var SearchResultsContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 30,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(0, "px"),
        },
        _b);
});
var ContentWrapper = styled(Grid)((_a = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        width: '100%'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        padding: "".concat(0, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        padding: "".concat(0, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var findMostCommonBrandId = function (searchProducts) {
    var brandCounts = new Map();
    var mostCommonBrandId = undefined;
    var maxCount = 0;
    for (var _i = 0, searchProducts_1 = searchProducts; _i < searchProducts_1.length; _i++) {
        var product = searchProducts_1[_i];
        var count = (brandCounts.get(product.brandId) || 0) + 1;
        brandCounts.set(product.brandId, count);
        if (count >= maxCount) {
            maxCount = count;
            mostCommonBrandId = product.brandId;
        }
    }
    return mostCommonBrandId;
};
var SearchHeader = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: theme.palette.primary.main,
        marginBottom: 38,
        marginTop: 30,
        '.headerText': {
            fontSize: 16,
            fontWeight: 600,
        },
    });
});
var PaginationContainer = styled('div')((_b = {
        textAlign: 'right'
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        fontSize: 20,
    },
    _b));
var SearchResults = function (_a) {
    var _b, _c;
    var _d, _e, _f;
    var LinkComponent = _a.LinkComponent, apolloClient = _a.apolloClient, useSearchParams = _a.useSearchParams, pageContext = _a.pageContext, onShareClick = _a.onShareClick, handleJoinClub = _a.handleJoinClub, useNavigate = _a.useNavigate, appConfig = _a.appConfig, props = __rest(_a, ["LinkComponent", "apolloClient", "useSearchParams", "pageContext", "onShareClick", "handleJoinClub", "useNavigate", "appConfig"]);
    var _g = useState([]), popularProducts = _g[0], setPopularProducts = _g[1];
    var navigate = useNavigate();
    var locationPathname = window.location.pathname;
    var _h = useSearchParams(), searchParams = _h[0], setSearchParams = _h[1];
    var _j = useState(true), loading = _j[0], setLoading = _j[1];
    var _k = useState(0), totalResultCount = _k[0], setTotalResultCount = _k[1];
    var _l = useState(false), filterDialogOpen = _l[0], setFilterDialogOpen = _l[1];
    var _m = useState(undefined), mostPopularBrand = _m[0], setMostPopularBrand = _m[1];
    var searchRequestBody = searchParamsToSearchFilters(searchParams, pageContext);
    var searchTerms = (_d = searchRequestBody === null || searchRequestBody === void 0 ? void 0 : searchRequestBody.titleInclude) === null || _d === void 0 ? void 0 : _d.join(' ');
    var searchText = searchTerms !== null && searchTerms !== void 0 ? searchTerms : 'All products';
    var _o = useState(searchTerms), searchInputText = _o[0], setSearchInputText = _o[1];
    var isSignedIn = !!props.userProfile;
    var _p = useJoinBrandClubWithRedirect({
        brand: mostPopularBrand,
        handleJoinClub: handleJoinClub,
        navigate: navigate,
    }), joinedState = _p.joinedState, handleJoin = _p.handleJoin, campaignRewards = _p.campaignRewards;
    var fetchBrandclub = useCallback(function (brandIds, searchTerm) {
        if (brandIds === void 0) { brandIds = []; }
        return __awaiter(void 0, void 0, void 0, function () {
            var titleInclude, RES_KEY, query, res, e_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        titleInclude = undefined;
                        if (searchTerm && !brandIds.length) {
                            titleInclude = [searchTerm];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        RES_KEY = isSignedIn ? 'SearchBrandClubsForUserV2' : 'UnauthedSearchBrandClubs';
                        query = isSignedIn ? searchBrandClubsForUserV2 : getUnauthedSearchBrandClubs;
                        return [4 /*yield*/, apolloClient.query({
                                query: query,
                                variables: {
                                    page: {
                                        start: 0,
                                        size: 1,
                                    },
                                    titleInclude: titleInclude,
                                    brandIds: brandIds,
                                    searchIntent: 'InAppSearch',
                                },
                                fetchPolicy: 'network-only',
                            })];
                    case 2:
                        res = _d.sent();
                        setMostPopularBrand((_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a[RES_KEY]) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c[0]);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        console.error(e_1);
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [isSignedIn]);
    useEffect(function () {
        // Update the search input text when the search terms change
        setSearchInputText(searchTerms);
    }, [searchTerms]);
    useEffect(function () {
        // close the filter dialog when the location changes
        setFilterDialogOpen(false);
    }, [locationPathname]);
    var page = _toNumber(searchParams.get('page'));
    var movePrev = function () {
        searchParams.set('page', "".concat(page - PAGE_SIZE));
        window.scrollTo({ top: 0, behavior: 'auto' });
        setSearchParams(searchParams);
    };
    var moveNext = function () {
        searchParams.set('page', "".concat(page + PAGE_SIZE));
        window.scrollTo({ top: 0, behavior: 'auto' });
        setSearchParams(searchParams);
    };
    useEffect(function () {
        if (apolloClient) {
            var fetchProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
                var treatment, data, mostPopularBrandId;
                var _a, _b, _c, _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            setLoading(true);
                            treatment = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments) && (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment)
                                ? {
                                    search: pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment,
                                }
                                : undefined;
                            return [4 /*yield*/, apolloClient.query({
                                    query: UNAUTHENTICATED_SEARCH_PRODUCTS,
                                    variables: __assign(__assign({}, searchRequestBody), { page: {
                                            start: page,
                                            size: PAGE_SIZE,
                                        }, computeFacets: true, facetFieldNames: ['categoryId', 'retailerId', 'subCategoryId', 'brandId'], treatment: treatment }),
                                })];
                        case 1:
                            data = (_h.sent()).data;
                            if (!(page === 0 && ((_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.domainConfig) === null || _a === void 0 ? void 0 : _a.storeBrandingType) === StoreBrandingType.UniversalStore)) return [3 /*break*/, 3];
                            mostPopularBrandId = findMostCommonBrandId(
                            // The brandclub app only fetches 20 products at a time and only use those 20 to calculate the most popular brand.
                            // To ensure we display the same results even though we fetch more products, we only use the first 20 products and only on the first page.
                            // See https://gitlab.com/stackline-dev/brandclub-mobile-app/-/blob/5e55fd3d9da2211dbb7194745e8aa87da9e4606c/src/screens/Shop/SearchResultsPage.tsx#L203 for reference
                            (_c = (_b = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.slice(0, 20));
                            return [4 /*yield*/, fetchBrandclub(mostPopularBrandId != null ? [mostPopularBrandId] : undefined, searchTerms)];
                        case 2:
                            _h.sent();
                            _h.label = 3;
                        case 3:
                            setTotalResultCount((_e = (_d = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _d === void 0 ? void 0 : _d.totalProducts) !== null && _e !== void 0 ? _e : 0);
                            setPopularProducts((_g = (_f = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _f === void 0 ? void 0 : _f.products) !== null && _g !== void 0 ? _g : []);
                            setLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchProducts();
        }
    }, [apolloClient, appConfig, searchParams, fetchBrandclub]);
    var hasResults = !loading && popularProducts.length;
    var disableBack = page === 0;
    var totalPages = Math.ceil(totalResultCount / PAGE_SIZE);
    var disableNext = page + 1 >= totalPages;
    return (React.createElement(SearchResultsContainer, null,
        React.createElement(ContentWrapper, null,
            React.createElement(FilterDialog, { searchInput: searchInputText, setSearchInput: setSearchInputText, brandId: (_e = props.brandEntity) === null || _e === void 0 ? void 0 : _e.id, routePrefix: props.routePrefix, navigate: navigate, open: filterDialogOpen, onClose: function () { return setFilterDialogOpen(false); }, persistentQueryParams: props.persistentQueryParams, searchParams: searchParams, pageContext: pageContext, axios: props.axios }),
            React.createElement(SearchHeader, { container: true, wrap: "nowrap", gap: 1 }, loading ? (React.createElement("div", { className: "headerText" },
                ' ',
                React.createElement(Typography, { component: "h2", fontSize: 24, fontWeight: "bold", display: "inline-flex", alignItems: "center", overflow: "hidden", whiteSpace: "nowrap", sx: (_b = {},
                        _b["@media screen and (max-width:  390px)"] = {
                            display: 'inline',
                            textOverflow: 'ellipsis',
                        },
                        _b) }, "Searching..."))) : hasResults ? (React.createElement(React.Fragment, null,
                React.createElement(Typography, { component: "h2", fontSize: 24, fontWeight: "bold", display: "inline-flex", alignItems: "center", overflow: "hidden", whiteSpace: "nowrap", sx: (_c = {},
                        _c["@media screen and (max-width:  390px)"] = {
                            display: 'inline',
                            textOverflow: 'ellipsis',
                        },
                        _c) },
                    "Search results for \u201C",
                    React.createElement(Box, { component: "span", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, searchText),
                    "\u201D"),
                React.createElement(Button, { sx: { height: 'auto', whiteSpace: 'nowrap' }, onClick: function () { return setFilterDialogOpen(true); } }, "Filter"))) : (React.createElement("div", { className: "headerText" },
                "No search results were returned for \u201C",
                searchText,
                "\u201D. Please try another query."))),
            React.createElement(SearchProductGrid, { onShareClick: onShareClick, loading: loading, LinkComponent: LinkComponent, products: popularProducts }, mostPopularBrand && (React.createElement(ProductBrandCard, { brand: mostPopularBrand, joinedState: joinedState, reward: ((_f = campaignRewards[0]) === null || _f === void 0 ? void 0 : _f.rewardAmount) || 0, joined: mostPopularBrand.isMember, onJoin: handleJoin, LinkComponent: LinkComponent }))),
            hasResults && (!disableBack || !disableNext) ? (React.createElement(PaginationContainer, null,
                React.createElement(IconButton, { disableRipple: true, disableFocusRipple: true, onClick: movePrev, disabled: disableBack },
                    React.createElement(ChevronLeftIcon, { sx: function (theme) { return ({ color: theme.palette.primary.main, opacity: disableBack ? 0.5 : 1 }); } })),
                React.createElement(IconButton, { disableRipple: true, disableFocusRipple: true, onClick: moveNext, disabled: disableNext },
                    React.createElement(ChevronRightIcon, { sx: function (theme) { return ({ color: theme.palette.primary.main, opacity: disableNext ? 0.5 : 1 }); } })))) : null)));
};

export { SearchResults };
//# sourceMappingURL=SearchResults.js.map
